import * as constants from 'helper/constants';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import React, { PureComponent } from 'react';
import strings from 'helper/localization/localization';

import MockAPI from 'helper/mockApi'; // for prop-types
import API from '../../api/api'; // for prop-types

export default class Consents extends PureComponent {
  constructor(props) {
    super(props);

    // Properties
    this.api = this.props.api;
    this.updateUser = this.props.updateUser;
    this.userAttrsToUpdate = {};

    // State
    this.state = {
      editSaved: false,
    };

    // Bindings
    this.submitChanges = this.submitChanges.bind(this);
    this.researchChanged = this.researchChanged.bind(this);
  }

  submitChanges(e) {
    e.preventDefault();
    // acceptedContactUsageVersion must be null instead of 0 when sending a val
    const updateArgs = { acceptedContactUsageVersion: this.userAttrsToUpdate.acceptedContactUsage ? 1 : null };

    this.api.updateUser(
      updateArgs,
      (api) => {
        if (api.status === constants.api.success) {
          this.updateUser({ ...api.res.body });
          this.setState({ editSaved: true });
        }
      },
    );
  }

  researchChanged(event) {
    this.userAttrsToUpdate.acceptedContactUsage = event.target.checked;
  }

  render() {
    const redirect = (<Redirect
      push
      to={{
      pathname: '/account/manage',
      state: { successMessage: strings.consentsUpdated },
    }}
    />);
    const postSaveRedirect = this.state.editSaved ? redirect : null;

    return (
      <div className="container">
        { postSaveRedirect }

        <div className="row">
          <div className="col">
            <Link to="/account/manage" className="back">
              {strings.back}{' - '}{strings.manageMyAccount}
            </Link>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col">
            <h2 id="account-consents--title" className="mb-0">{strings.myConsents}</h2>
          </div>
        </div>

        <form>
          <div className="row">
            <div className="col">
              <h5>{strings.consentedTo}</h5>
            </div>
          </div>

          <div className="form-group mt-4">
            <div className="custom-control custom-checkbox">
              <input
                className="custom-control-input"
                type="checkbox"
                value=""
                id="researchCheck"
                defaultChecked={this.props.acceptedContactUsage}
                onChange={this.researchChanged}
              />
              <label className="custom-control-label text-alternate" id="researchCheckLabel" htmlFor="researchCheck">
                {strings.researchCheckbox}
              </label>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-outline-primary btn-lg btn-block"
            onClick={this.submitChanges}
            id="account--save"
          >
            {strings.saveChanges}
          </button>
        </form>
      </div>
    );
  }
}

Consents.propTypes = {
  acceptedContactUsage: PropTypes.bool,
  /** api object used to set a new password */
  api: PropTypes.oneOfType([
    PropTypes.instanceOf(API),
    PropTypes.instanceOf(MockAPI),
  ]).isRequired,
  /** api call to update the user */
  updateUser: PropTypes.func.isRequired
};

Consents.defaultProps = {
  acceptedContactUsage: false
};



// WEBPACK FOOTER //
// ./src/modules/accountManagement/Consents.jsx